export default __webpack_public_path__ + "static/media/ContractChangeLarge.c721599c.svg";